export default __webpack_public_path__ + "static/footer-logos-6a7f865458e7111ebff9d65b618065bd.png";